import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useToast } from '../../context/ToastContext'
import { Input } from '../../components/forms'
import Button from '../../components/ui/Button'

function LoginForm() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const { signIn, isDemoMode } = useAuth()
  const navigate = useNavigate()
  const toast = useToast()

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!email || !password) {
      toast.error('Please enter email and password')
      return
    }

    setLoading(true)

    const { user, error } = await signIn(email, password)

    setLoading(false)

    if (error) {
      toast.error(error)
      return
    }

    toast.success('Welcome back!')
    navigate('/dashboard')
  }

  const fillDemoCredentials = () => {
    setEmail('demo@secondshiftventures.com')
    setPassword('demo123')
  }

  return (
    <form onSubmit={handleSubmit}>
      <Input
        label="Email"
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        autoComplete="email"
        required
      />

      <div className="form-group">
        <label className="form-label">Password</label>
        <div style={{ position: 'relative' }}>
          <input
            type={showPassword ? 'text' : 'password'}
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            autoComplete="current-password"
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '0.875rem',
              color: 'var(--gray-500)'
            }}
          >
            {showPassword ? '👁️' : '👁️‍🗨️'}
          </button>
        </div>
      </div>

      <Button
        type="submit"
        variant="primary"
        className="w-full mt-4"
        loading={loading}
      >
        Sign In
      </Button>

      {isDemoMode && (
        <div className="mt-4" style={{ textAlign: 'center' }}>
          <p className="text-sm text-muted mb-2">Demo Mode Active</p>
          <button
            type="button"
            onClick={fillDemoCredentials}
            className="text-sm"
            style={{ color: 'var(--primary-600)', background: 'none', border: 'none', cursor: 'pointer' }}
          >
            Use demo credentials
          </button>
        </div>
      )}

      <div className="login-footer">
        <p className="text-sm text-muted">
          Don't have an account?{' '}
          <Link to="/signup">Sign up</Link>
        </p>
      </div>
    </form>
  )
}

export default LoginForm
